export const projectsData = [
  {
    id: 1,
    title: 'Smart WiFi Switch (ESP8266)',
    problem:
      'Most low-cost smart switches are either locked to vendor clouds or too fragile for real-world customization.',
    solution:
      'Built custom firmware with WiFi provisioning, MQTT + API control, and app integration patterns inspired by eWeLink-class products.',
    tech: ['ESP8266', 'Custom Firmware', 'MQTT', 'REST APIs', 'Mobile App Integration'],
    impact:
      'Shipped a product-oriented architecture focused on onboarding reliability, remote control consistency, and extensibility.'
  },
  {
    id: 2,
    title: 'Smart Home Controller (ESP8266 + Cloud)',
    problem:
      'Internet dependency makes many smart-home systems unreliable during network instability.',
    solution:
      'Designed an offline-first controller with local automation, optional cloud sync, and MQTT/API interfaces for interoperability.',
    tech: ['ESP8266', 'MQTT', 'API Integration', 'Cloud Sync'],
    impact:
      'Improved real-world availability by keeping core automation active even when cloud connectivity is interrupted.'
  },
  {
    id: 3,
    title: 'ESP32 Notification System',
    problem:
      'Embedded devices often lack low-latency channels for delivering mobile alerts and call notifications.',
    solution:
      'Implemented a real-time communication pipeline to forward mobile alerts to ESP32 hardware instantly.',
    tech: ['ESP32', 'Real-time Messaging', 'Mobile Integration'],
    impact:
      'Enabled immediate event awareness and faster device-side response for critical notifications.'
  },
  {
    id: 4,
    title: 'Turf Booking App',
    problem:
      'Manual or fragmented booking flows cause slot conflicts and poor user experience for sports facilities.',
    solution:
      'Built a modern booking app with email/Google authentication, slot management, and a clean UI. Razorpay support planned for checkout.',
    tech: ['React', 'Flutter', 'Firebase', 'Authentication', 'Booking Engine'],
    impact:
      'Streamlined booking operations and laid the foundation for a monetizable booking platform.'
  },
  {
    id: 5,
    title: 'OCR Patient Form Digitization System',
    problem:
      'Healthcare teams spend excessive time manually transcribing scanned forms into digital records.',
    solution:
      'Created an OCR pipeline that extracts data from PDFs/images, converts it to structured JSON, and stores records in SQL.',
    tech: ['Python', 'OCR', 'Image Processing', 'JSON', 'SQL'],
    impact:
      'Reduced manual workload and improved data consistency for operational healthcare workflows.'
  },
  {
    id: 6,
    title: 'Cattle Identification using Muzzle Images',
    problem:
      'Reliable livestock identification is difficult at scale without robust visual intelligence systems.',
    solution:
      'Trained and evaluated CNN architectures (MobileNetV2, EfficientNet) for muzzle-image classification.',
    tech: ['TensorFlow', 'Keras', 'MobileNetV2', 'EfficientNet', 'Computer Vision'],
    impact:
      'Demonstrated a practical AI use-case for agriculture with potential for traceability and farm automation.'
  },
  {
    id: 7,
    title: 'Custom PCB Design Projects',
    problem:
      'Prototype boards often become bottlenecks when moving toward compact deployment-ready hardware.',
    solution:
      'Designed ESP-12E based custom sensor PCBs with DHT11, BMP180, ADXL345 and integrated power/programming interfaces.',
    tech: ['KiCad', 'ESP-12E', 'PCB Design', 'Circuit Design', 'Sensor Integration'],
    impact:
      'Bridged the gap between prototype and deployable hardware with cleaner integration and maintainable board design.',
    link: '/wiki/ms-g030'
  }
]
